import { memo, useEffect, useLayoutEffect, useState } from 'react';
import classNames from 'classnames';
import { selectSettings } from 'ducks/settings/selectors';
import Lottie from 'lottie-react';
import { useAppSelector } from 'store/hooks';

import voladeum from './loading.json';

import cn from './Loading.module.scss';

export const Loading = memo(() => {
  const { loading } = useAppSelector(selectSettings);
  const [visible, setVisible] = useState(false);

  useLayoutEffect(() => {
    if (loading) {
      setVisible(true);
    }
  }, [loading]);

  useEffect(() => {
    if (!loading) {
      setTimeout(() => {
        setVisible(false);
      }, 400);
    }
  }, [loading]);

  if (!loading && !visible) return null;

  return (
    <>
      <div className={cn.blur} />
      <div className={classNames(cn.loading, cn.dark)}>
        <Lottie animationData={voladeum} style={{ height: 200, width: 'auto' }} />
      </div>
    </>
  );
});

export const SmallSpinner = () => (
  <Lottie animationData={voladeum} style={{ height: 75, width: 'auto' }} />
);

export const LargeSpinner = () => (
  <Lottie animationData={voladeum} style={{ height: 200, width: 'auto' }} />
);
